export default __webpack_public_path__ + "static/media/nepaltv.db4f56ea.jpg";